"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var productsElem = document.querySelector('.products-container#products');
var productsHeader = document.querySelector('.products-header');
var addClass = function () {
    productsHeader.className += ' active';
    return;
};
var productsSlider = document.querySelectorAll('.product-slider');
var current = 1;
var setClass = function (index) {
    productsSlider.forEach(function (content, idx0) {
        if (index === idx0)
            return (content.className = 'product-slider active');
        if (index - 1 === idx0)
            return (content.className = 'product-slider prev');
        if (index + 1 === idx0)
            return (content.className = 'product-slider next');
        if (index === productsSlider.length - 1 && idx0 === 0)
            return (content.className = 'product-slider next');
        return (content.className = 'product-slider');
    });
};
document.addEventListener('DOMContentLoaded', function () {
    var observer = new IntersectionObserver(function (_a) {
        var entry = _a[0];
        if (entry && entry.isIntersecting) {
            addClass();
            observer.disconnect();
        }
    }, {
        threshold: 0.4,
    });
    setClass(1);
    setInterval(function () {
        if (current + 2 > productsSlider.length) {
            current = 0;
            setClass(0);
        }
        setClass(current + 1);
        current += 1;
        return;
    }, 7500);
    observer.observe(productsElem);
});
